module.exports = __webpack_public_path__ + "img/042.01e404d7.jpg";